import { BaseTLTableComponent, SettingFilter, SettingService, AxiosResponse, UserService, Watch } from "../../../Infrastructure/CorBase/CoreBase";
	
	export default abstract class SettingListBase extends BaseTLTableComponent {
		//VaPTODO - sdilenou funkcionalitu co jsem rozkopiroval i do SettingDetail.vue idealne zkusit nejak presunout do spolecne tridy, mixinu nebo nejak jinak implementovat pouze jednou
		//        - prime dedeni neni mozne, jelikoz list a detail musi mit jineho predka ;-(
		userService: UserService = new UserService();
		
		paramTypeGlobal: string = 'global';
		paramTypeTenant: string = 'tenant';
		isGlobalSetting: boolean = false;
		isTenantSetting: boolean = false;

		//idUser = -1;

		settingEnums: any[] = [];
		items: any[] = [];
		defaultEnum = '1';

		paramUserId = '';
		paramUserName = '';
		paramGoBack = '';

		idSettingGroup = '';
		protected queryBase: any;

		protected createdBase() {
			this.allowEdit = this.allowEditBase();
			//this.loadQuery = this.$router.currentRoute.query;
			this.paramGoBack = String(this.$router.currentRoute.query.goBack);
			this.paramUserId = String(this.$router.currentRoute.query.userId);
			this.loadName();
		}

		loadName() {
			if (Number(this.paramUserId)>0) {
				this.userService.getById(Number(this.paramUserId)).then(res => {
					this.paramUserName = res.data.name;
				});
			}
		}

		loadDefault(idGroup: string) {
			if (Number(idGroup) == 0) {
				this.idSettingGroup = this.defaultEnum;
			}
		}

		protected allowEditBase(): boolean {
			return this.canRead || this.idUserMain() == this.$store.state.idUser ;
		}
		protected goBackPageBase(): void {			
			this.$router.push({
				name: "UserDetail", params: { id: this.idUserMain().toString(), type: "details", nameUser: String(this.$router.currentRoute.query.nameUser) }
				, query: { id: this.idUserMain().toString(), type: "details", nameUser: String(this.$router.currentRoute.query.name) }
			});
		}

		protected goBackName(): string {
			return this.$t('setting.goBackUser').toString() +  this.paramUserName;
		}

		get isUserSetting(): boolean {
			return !(this.isTenantSetting || this.isGlobalSetting);
		}

		get idUserFromParam(): number | undefined {
			let userIdString: string = this.idUserFromParamString;
			if (userIdString != null && (userIdString !== '') && !isNaN(Number(userIdString))) {
				return Number(userIdString);
			}
			return undefined;
		}

		get getGoBack(): string {			
			return this.paramGoBack;
		}


		get showBackButton(): boolean {
			return  this.paramGoBack != 'undefined' ;
		}

		get idUserFromParamString(): string{
			return this.paramUserId;
		}

		//get paramType(): string {
		//	if (this.isGlobalSetting) {
		//		return this.paramTypeGlobal;
		//	} else if (this.isTenantSetting) {
		//		return this.paramTypeTenant;
		//	}
		//	return '';
		//}

		get idUserFromStore(): number {
			return Number(this.$store.state.idUser);
		}

		//get idUser(): number {
		//	let userId: number = this.idUserFromStore;
		//	if (this.paramUserId != '' && this.paramUserId != undefined) {
		//		userId = Number(this.paramUserId);
		//	}
		//	if (Number.isNaN(userId)) {
		//		userId = 0;
  //          }
		//	return userId;
		//}

		idUserMain(): number {
			let userId: number = this.idUserFromStore;
			if (this.paramUserId != '' && this.paramUserId != undefined) {
				userId = Number(this.paramUserId);
			}
			if (Number.isNaN(userId)) {
				userId = 0;
			}
			return userId;
		}

		settingService: SettingService = new SettingService();

		initializeRightsLocal() {
			if (this.isGlobalSetting) {
				super.initializeRights(undefined, undefined, 'COR_Setting_Global', 'COR_Setting_Global');
			}
			else if (this.isTenantSetting){
				super.initializeRights(undefined, undefined, 'COR_Setting_Tenant', 'COR_Setting_Tenant');
			}
			else {
				super.initializeRights(undefined, undefined, 'COR_Setting_User', 'COR_Setting_User');
			}
		}

		isOwner(): boolean {
			return this.isUserSetting && this.idUserFromParam == this.idUserFromStore;
		}

		setIsGlobalSetting() {
			this.isGlobalSetting = false;
			this.isTenantSetting = false;
			var paramType = this.$router.currentRoute.query.type;

			if (paramType != undefined) {
				this.$store.commit("settingType", paramType);
			}
			else {
				paramType = this.$store.state.settingType;
			}

			if (paramType) {
				this.isGlobalSetting = paramType === this.paramTypeGlobal;
				this.isTenantSetting = paramType === this.paramTypeTenant;
			}
		}


		fetchDataFromServer(): Promise<AxiosResponse<any>> {
			let filter: SettingFilter = new SettingFilter(null, this.isGlobalSetting, this.isTenantSetting, this.isUserSetting, this.$store.state.idTenant, this.idUserMain(), null);
			var allItems =  this.settingService.getAllByFilter(filter);
			//this.settingEnums = [];
			allItems.then(response => {
				this.items = response.data;
				for (var i = 0; i < this.items.length; i++) {

					if (this.settingEnums.filter((c: any) => c.value == this.items[i].idSettingGroup).length == 0) {
						this.settingEnums.push({ value: this.items[i].idSettingGroup, text: this.items[i].idSettingGroupNavigationName, description: this.items[i].idSettingGroupNavigationDescription });
					}
				}				
				this.settingEnums = this.settingEnums.sort((a, b) => a.text.localeCompare(b.text));
			
				if (Number(this.idSettingGroup) > -1 ) {
					this.defaultEnum = this.idSettingGroup;
				}
				else {
					this.defaultEnum = this.settingEnums[0].value;
				}
				this.setfilters(null);
			});
			
			return allItems;
		}

		//zatím nepotrebujeme
		fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
			return this.fetchDataFromServer();
		}

		refreshItems(items: any[], refreshData: any[]) {
			return items;
		}

		prepareItems(items: any[]) {
			for (var i = 0; i < items.length; i++) {
				items[i].creationDate = new Date(items[i].creationDate).toLocaleDateString();
				if (items[i].isBoolean) {
					items[i].defaultValue = items[i].defaultValue == "true" ? this.$t('setting.answerYes').toString() : this.$t('setting.answerNo').toString();
				}
			}
		}

		loadFilters(value: any) { super.loadFilters(value); };
		detailClick(elementId: any) {
			super.detailClick(elementId);
		};

		getOptionalParams() {		
			this.idSettingGroup = String(this.$route.query['idSettingGroup']);
			//if (this.isGlobalSetting) {
			//	return { goBack: "SettingGlobalList",  type: "global", idSettingGroup: this.idSettingGroup };
			//}
			//else if (this.isTenantSetting) {
			//	return { goBack: "SettingTenantList",  type: "tenant", idSettingGroup: this.idSettingGroup };
			//}
			//else {
			//	return { userId: this.idUserFromParamString, goBack: "SettingUserList", nameUser: this.paramUserName, type: "user", idSettingGroup: this.idSettingGroup };
			//}
			if (this.isGlobalSetting) {
				return {  type: "global", idSettingGroup: this.idSettingGroup };
			}
			else if (this.isTenantSetting) {
				return {  type: "tenant", idSettingGroup: this.idSettingGroup };
			}
			else {
				return { userId: this.idUserFromParamString,  nameUser: this.paramUserName, type: "user", idSettingGroup: this.idSettingGroup };
			}
		}


		setFields() {
			this.fields = [
				{ key: 'name', label: this.$t('setting.fieldName'), trans: 'setting.fieldName', sortable: true, class: 'text-left', design: 'detail', thClass: 'firstColumnMichael' },
				{ key: 'description', label: this.$t('setting.fieldDescription'), trans: 'setting.fieldDescription', sortable: true, class: 'text-left' },
				{ key: 'defaultValue', label: this.$t('setting.fieldValue'), trans: 'setting.fieldValue', sortable: true, class: 'text-left' },
				{ key: 'actions', label: this.$t('setting.fieldActions'), trans: 'setting.fieldActions', class: 'text-right', thClass: 'lastColumnMichael'
}
			]
		};


		//filtry
		setfilters(value: any) {
			
			if (value != null && value[0].lang == this.filters[0].lang) {
				this.filters = value;
			}
			else {
				this.filters = [
					{
						key: 'idSettingGroup', label: this.$t('setting.filterTypeSetting'), trans: 'setting.filterTypeSetting', selected: true, value: this.defaultEnum, default: this.defaultEnum, type: 'text', useOwnEnumsSend: true,
						useOwnEnumsSendArray: this.settingEnums, useEnum: true, refItem: 'idSettingGroup', showAnyTime: true, lang: this.$store.state.currentLanguage
					},

					{ key: 'name', label: this.$t('setting.filterName'), trans: 'setting.filterName', selected: false, value: null, type: 'text' },
					{ key: 'description', label: this.$t('setting.filterDescription'), trans: 'setting.filterDescription', selected: false, value: null, type: 'text' },
					{ key: 'defaultValue', label: this.$t('setting.filterValue'), trans: 'setting.filterValue', selected: false, value: null, type: 'text' }
				];
			}
		}
	
	};